module.exports = __webpack_public_path__ + "images/mobile/img-empty-notifications-132794e3629c12ac275de247f8e977a4.png";